import { v as m } from "./uuid-5adc31c9.js";
import { useState as l, useCallback as p } from "react";
import { g as D } from "./@aws-amplify-21547700.js";
var b = /* @__PURE__ */ ((e) => (e.Initiated = "INITIATED", e.Connecting = "CONNECTING", e.Connected = "CONNECTED", e.Abandoned = "ABANDONED", e.Agent_Disconnect = "AGENT_DISCONNECT", e.User_Disconnect = "USER_DISCONNECT", e.Ended = "ENDED", e.Transferred = "TRANSFERRED", e.Accepted = "ACCEPTED", e.Agent_Busy = "AGENT_BUSY", e.Agent_Abandon = "AGENT_ABANDON", e.Agent_Ended = "AGENT ENDED", e.Chat_Retry = "CHAT_RETRY", e.Transferring = "TRANSFERRING", e))(b || {}), u = /* @__PURE__ */ ((e) => (e.Agent = "AGENT", e.User = "USER", e))(u || {}), v = /* @__PURE__ */ ((e) => (e.TechSupportInput = "TechSupportInput", e.Disabled = "Disabled", e.Hidden = "Hidden", e.TechSupportChatbotInput = "TechSupportChatbotInput", e))(v || {});
const G = (e, r, o, c = "user", n = "agent", s) => ({
  messageId: m(),
  visitorId: r,
  conversationId: o,
  sender: c,
  source: c,
  content: e,
  recipient: n,
  createdAt: (/* @__PURE__ */ new Date()).toISOString(),
  interactionType: "Online",
  isSent: !1,
  messageType: s ?? "Plain Text",
  isActive: !0,
  sourceLang: "en",
  targetLang: "en",
  translated: !1
}), O = async (e) => {
  try {
    const r = [
      ...document.querySelectorAll(`.${e.toLocaleLowerCase()}-node`)
    ].at(-1);
    if (r) {
      const { default: o } = await import("./html2canvas-c76dc20e.js").then((s) => s.h);
      return (await o(r, { scale: 1 })).toDataURL("image/webp", 1);
    }
  } catch (r) {
    console.error("Failed to convert to canvass", r);
  }
}, R = D({ authMode: "userPool" }), U = ({ query: e, onData: r, onError: o, onSettled: c }) => {
  const [n, s] = l(), [T, E] = l([""]), N = p((t) => {
    n != null && n.closed && setTimeout(() => {
      n == null || n.unsubscribe(), i(T);
    }, 5e3), o == null || o(t);
  }, []), i = (t) => {
    let a = e;
    t.forEach((d, g) => {
      a = a.replace(`{${g + 1}}`, d);
    });
    const A = R.graphql({
      query: a
    }).subscribe({
      next: (d) => r(d),
      error: N,
      complete: c
    });
    E(t), s(A);
  };
  return {
    subscription: n,
    connect: i
  };
};
export {
  b as C,
  u as a,
  G as b,
  O as c,
  v as d,
  U as u
};
